module.exports = __webpack_public_path__ + "img/sk-logo-1.a0f42cf7.png";